/* eslint-disable complexity */
/* eslint-disable max-len */
import * as React from 'react';
import {SetStateAction, useCallback, useEffect, Key, useState, useMemo, ReactElement} from 'react';
import cx from 'classnames';
import {TopicModule} from '@/services/pages/channel/channel.client';
import {
    SELF_TOPIC_CONTENT_NAME,
    SELF_TOPIC_IMAGE_NAME,
    SELF_TOPIC_CONTENT_TYPE_SINGLEABS,
    SELF_TOPIC_IMAGE_TYPE_HORIZONTAL,
    SELF_TOPIC_TOFU_CUBE_NAME,
    SELF_TOPIC_CONTENT_TYPE_HORIZONTAL,
    SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL,
    SELF_TOPIC_CONTENT_TYPE_FLOW_BIG,
    SELF_TOPIC_IMAGE_TYPE_BANNER,
    SELF_TOPIC_IMAGE_TYPE_GOLD_ICON,
    SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_SWIPER,
    SELF_TOPIC_CONTAINER,
    SELF_TOPIC_EXPERT,
    SELF_TOPIC_TAB_NAME,
    SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING,
    // 图片模块 - value:19 图片大尺寸样式
    SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL,
} from '@/dicts/modelConsts';
import SelfTopicContentHorizontal from '@/pages/specialDisease/hotContent';
import DiseaseBannerSwipe from '@/pages/specialDisease/swiper';
import DiseaseGoldIcons from '@/pages/specialDisease/goldIcons';
import VideoSwpier from '@/pages/specialDisease/videoSwiper';
import {VALUE_TYPE} from '@/dicts/consts';
import Tabs from '../SimpleTabs';
import SelfTopicContentSingleAbstract from '../common/singleAbstract';
import SelfTopicImageHorizontal from '../imgHorizontal';
import SelfTopicTofuText from '../tofuText';
import SelfTopicContentFlowBig from '../flowBig';
import SelfTopicContentFlowSmall from '../flowSmall';
import SelfTopicImgDoubleColumn from '../doubleColumn';
import SelfTopicImgSpecialDoubleColumn from '../specialDoubleColumn';
import SelfTopicContainerVertical from '../containerVertical';
import SelfTopicExpert from '../selfTopicExpert';
import Title from '../common/title';
import SeamlessPuzzle from '../seamlessPuzzle';
import styles from './index.less';


interface Props {
    page: string;
    sfRef?: string;
    infos: TopicModule;
    channelBusinessLine?: string;
}

const SelfTopicContainerAggregation = ({infos, page, sfRef, channelBusinessLine}: Props) => {


    const [tabs, setTabs] = useState<string[]>([]);
    const [activeKey, setActiveKey] = useState<Key>(
        () => {
            return infos?.subModuleList?.[0]?.moduleId;
        }
    );


    const handleTabsChange = useCallback(
        activeKey => {
            setActiveKey(activeKey);
        },
        []
    );

    useEffect(
        () => {
            const list: SetStateAction<string[]> = [];
            infos.subModuleList?.map(
                // eslint-disable-next-line array-callback-return
                module => {
                    const tabName = `${module.moduleName}${module.moduleSubTitle}`;
                    list.push(tabName);
                }
            );
            if (list.length) {
                setTabs(list);
            }
        },
        [activeKey, channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, infos.subModuleList, page, sfRef]
    );

    const getCusStyle = (moduleItem: TopicModule) => {
        const styleObj = {
            backgroundColor: moduleItem.moduleBgc ? moduleItem.moduleBgc : 'white',
            borderRadius: moduleItem.moduleFillet === 1 ? '0px' : '12px',
            marginRight: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginLeft: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginTop: moduleItem.moduleSpaceBack === 1 ? '0' : '8px',
        };
        return styleObj ?? {};
    };

    const panes = useMemo(
        () => {
            const res: ReactElement[] = [];
            infos.subModuleList?.forEach(subModules => {
                const tabName = [subModules.moduleName ?? '', subModules.moduleSubTitle ?? ''];
                const tabInfo = {
                    moduleId: subModules.moduleId,
                    moduleName: subModules.moduleName,
                };

                switch (subModules.moduleEnName) {
                    case SELF_TOPIC_IMAGE_NAME:
                        switch (subModules.moduleStyle) {
                            case SELF_TOPIC_IMAGE_TYPE_BANNER:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        // eslint-disable-next-line max-len
                                                        className={(subModules.isShowTitle === 1 && (subModules.moduleName || subModules.moduleSubTitle))
                                                            ? styles.cardBg : styles.cardBottomBg}
                                                    >
                                                        <DiseaseBannerSwipe
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            bannersModel={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_HORIZONTAL:
                            case SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImageHorizontal
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_GOLD_ICON:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <DiseaseGoldIcons
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            goldIcons={{
                                                                channelId: subModules.channelId,
                                                                moduleId: subModules.moduleId,
                                                                golds: subModules.itemList,
                                                                moduleMaxColumns: subModules.moduleMaxColumns,
                                                                moduleName: subModules.moduleName,
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImgDoubleColumn
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImgSpecialDoubleColumn
                                                            page={page}
                                                            sfRef={sfRef}
                                                            infos={subModules}
                                                            channelBusinessLine={channelBusinessLine}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_SWIPER:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <VideoSwpier
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            bannersModel={subModules}
                                                            ubcValue="jump_shipinlunbo"
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>);
                                break;
                            case SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        className={styles(styles.cardBg, styles.noPaddingTop)}
                                                        style={getCusStyle(subModules)}
                                                    >
                                                        <SeamlessPuzzle
                                                            page={page}
                                                            sfRef={sfRef}
                                                            infos={subModules}
                                                            channelBusinessLine={channelBusinessLine}
                                                            ubcValue="jump_wufengpinjie"
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                        }
                        break;
                    case SELF_TOPIC_TOFU_CUBE_NAME:
                        res.push(
                            <Tabs.TabPane
                                key={subModules.moduleId ?? ''}
                                tab={tabName}
                                extInfo={tabInfo}
                            >
                                {
                                    subModules?.itemList?.length
                                        ? (
                                            <div
                                                key={subModules.moduleId}
                                                style={getCusStyle(subModules)}
                                                className={styles.cardBg}
                                            >
                                                <SelfTopicTofuText
                                                    page={page}
                                                    sfRef={sfRef}
                                                    infos={subModules}
                                                    channelBusinessLine={channelBusinessLine}
                                                />
                                            </div>
                                        )
                                        : null
                                }
                            </Tabs.TabPane>
                        );
                        break;
                    case SELF_TOPIC_CONTENT_NAME:
                        switch (subModules.moduleStyle) {
                            case SELF_TOPIC_CONTENT_TYPE_HORIZONTAL:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentHorizontal
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>);
                                break;
                            case SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentFlowSmall
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_CONTENT_TYPE_FLOW_BIG:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentFlowBig
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                                break;
                            case SELF_TOPIC_CONTENT_TYPE_SINGLEABS:
                                res.push(
                                    <Tabs.TabPane
                                        key={subModules.moduleId ?? ''}
                                        tab={tabName}
                                        extInfo={tabInfo}
                                    >
                                        {
                                            subModules?.itemList && subModules.itemList?.length
                                                ? (
                                                    <div
                                                        key={subModules.moduleId}
                                                        style={getCusStyle(subModules)}
                                                        className={cx(
                                                            styles.cardBg,
                                                            {
                                                                [styles.noPaddingCBg]: subModules.isShowTitle === 2,
                                                            }
                                                        )}
                                                    >
                                                        <SelfTopicContentSingleAbstract
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={subModules}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        }
                                    </Tabs.TabPane>
                                );
                        }
                        break;
                    case SELF_TOPIC_CONTAINER:
                        subModules.isShowTitle = 2;
                        res.push(
                            <Tabs.TabPane
                                key={subModules.moduleId ?? ''}
                                tab={tabName}
                                extInfo={tabInfo}
                            >
                                {
                                    subModules?.subModuleList?.length
                                        ? (
                                            <div
                                                key={subModules.moduleId}
                                                style={getCusStyle(subModules)}
                                            >
                                                <SelfTopicContainerVertical
                                                    page={page}
                                                    sfRef={sfRef}
                                                    channelBusinessLine={channelBusinessLine}
                                                    infos={subModules}
                                                />
                                            </div>
                                        )
                                        : null
                                }
                            </Tabs.TabPane>
                        );
                        break;
                    case SELF_TOPIC_TAB_NAME:
                        res.push(
                            <Tabs.TabPane
                                key={subModules.moduleId ?? ''}
                                tab={tabName}
                                extInfo={tabInfo}
                            >
                                {
                                    subModules?.itemList?.length
                                        ? (
                                            <div
                                                key={subModules.moduleId}
                                                style={getCusStyle(subModules)}
                                                className={styles.cardBg}
                                            >
                                                <SelfTopicTofuText
                                                    page={page}
                                                    sfRef={sfRef}
                                                    infos={subModules}
                                                    channelBusinessLine={channelBusinessLine}
                                                />
                                            </div>
                                        )
                                        : null
                                }
                            </Tabs.TabPane>
                        );
                        break;
                    case SELF_TOPIC_EXPERT:
                        res.push(
                            <Tabs.TabPane
                                key={subModules.moduleId ?? ''}
                                tab={tabName}
                                extInfo={tabInfo}
                            >
                                {
                                    subModules?.itemList?.length
                                        ? (
                                            <div
                                                key={subModules.moduleId}
                                                style={getCusStyle(subModules)}
                                                className={cx(
                                                    styles.cardBg,
                                                    {
                                                        [styles.noPaddingCBg]: subModules.isShowTitle === 2,
                                                    }
                                                )}
                                            >
                                                <SelfTopicExpert
                                                    page={page}
                                                    sfRef={sfRef}
                                                    channelBusinessLine={channelBusinessLine}
                                                    infos={subModules}
                                                />
                                            </div>
                                        )
                                        : null
                                }
                            </Tabs.TabPane>
                        );
                }
            });

            return res;
        },
        [channelBusinessLine, infos.subModuleList, page, sfRef]
    );
    const tabStyle = useMemo(
        () => ({color: infos?.moduleSelectColor}),
        [infos?.moduleSelectColor]
    );

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_rongqi_juhe',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle)
                && (
                    <div className={styles.titleWrap}>
                        <Title
                            title={infos.moduleName ?? ''}
                            subTitle={infos.moduleSubTitle ?? ''}
                            moreLink={infos.moreUrl ?? ''}
                            ubcExt={{
                                page: page,
                                value: 'jump_rongqi_gengduo',
                                pageSourceId: infos.channelId,
                                pageType: channelBusinessLine ?? '',
                                valueId: infos.moduleId,
                                valueTitle: infos.moduleName ?? '',
                            }}
                        />
                    </div>
                )
            }
            {
                tabs?.length ? (
                    <Tabs
                        activeKey={activeKey}
                        tabStyle={tabStyle}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={handleTabsChange}
                        page={page}
                        sfRef={sfRef}
                        infos={infos}
                        channelBusinessLine={channelBusinessLine}
                    >
                        {panes}
                    </Tabs>
                )
                    : null
            }

        </div>
    );
};

export default SelfTopicContainerAggregation;
